import { Injectable } from '@angular/core';
import { ProcessingResult } from '../processing-result';
import { Processor } from '../processor';
import { ProcessorModel } from '../processor-model';
import { CopyAnswerTagProcessor } from './copyAnswerTagProcessor';

@Injectable({
  providedIn: 'root',
})
export class CopyPaymentBankAuthorizationProcessor
  extends CopyAnswerTagProcessor
  implements Processor {
  mustWaitForFinish: boolean;
  stopIfError: any;
  name = 'CopyBankAuthorization';

  Process(model: ProcessorModel): Promise<ProcessingResult> {
    return this.copy(
      'Payment.BankMonthlyAuthorization',
      'Payment.BankInitialAuthorization'
    );
  }
}
